interface ReviewTypeSelectorProps {
  selected: string;
  onChange: (type: string) => void;
}

const reviewTypes = [
  {
    id: 'bug',
    name: 'Bug Detection',
    description: 'Find potential bugs, issues, and security vulnerabilities in your code.',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    id: 'optimization',
    name: 'Code Optimization',
    description: 'Get suggestions for improving performance, efficiency, and code quality.',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    ),
  },
  {
    id: 'readability',
    name: 'Code Readability',
    description: 'Improve code structure, naming, and documentation for better maintainability.',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
      </svg>
    ),
  },
];

export default function ReviewTypeSelector({ selected, onChange }: ReviewTypeSelectorProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {reviewTypes.map((type) => (
        <button
          key={type.id}
          onClick={() => onChange(type.id)}
          className={`flex flex-col items-start p-4 rounded-lg border-2 transition-all duration-200 ${
            selected === type.id
              ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20'
              : 'border-gray-200 dark:border-gray-700 hover:border-blue-300 dark:hover:border-blue-700'
          }`}
        >
          <div className="flex items-center space-x-3 mb-2">
            <div className={`${
              selected === type.id
                ? 'text-blue-500'
                : 'text-gray-500 dark:text-gray-400'
            }`}>
              {type.icon}
            </div>
            <h3 className={`font-medium ${
              selected === type.id
                ? 'text-blue-700 dark:text-blue-300'
                : 'text-gray-900 dark:text-white'
            }`}>
              {type.name}
            </h3>
          </div>
          <p className={`text-sm ${
            selected === type.id
              ? 'text-blue-600 dark:text-blue-400'
              : 'text-gray-500 dark:text-gray-400'
          }`}>
            {type.description}
          </p>
        </button>
      ))}
    </div>
  );
} 